import styled from 'styled-components';

export const StyledBanner = styled.div`
  margin-bottom: 1.75rem;
`;
